<template>
  <span
    class="
      tw-rounded-full
      tw-text-xs
      tw-leading-3
      tw-min-w-4
      tw-h-4
      tw-px-1
      tw-bg-sf-primary
      tw-text-sf-snow-lighter
      tw-inline-flex
      tw-justify-center
      tw-items-center
    "
  >
    <slot />
  </span>
</template>
